import { IAppState } from '../../store';

export const selectPhone = (state: IAppState) => state.personalLeadsForm.data.phone;
